/*
 * @Author: your name
 * @Date: 2022-03-02 22:09:09
 * @LastEditTime: 2022-03-09 15:14:22
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\personal\forgetpwd\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
  /** 页面名称 */
  title: '',
  login: false,
};

/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {}
export enum EnumGender {}
export default {
  en: {},
  zh: {},
};
